import React, { useContext } from 'react';
import { BetslipContext, isLiveBetting } from '../../data/betslip/BetslipConf';
import { taxesEnabled, getTaxPercentage } from '../../data/purchase-service';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { getLabel } from '../../data/labels';
import AmountBetslipForm from './AmountBetslipForm';
import StakesPicker from './StakesPicker';
import { UserContext } from '../../data/betslip/UserConf';
import BetslipButtons from './BetslipButtons';

function PotentialWinBox(props) {
	const betslipContext = useContext(BetslipContext);
    const userContext = useContext(UserContext);
    let betslipData = betslipContext.getBetslipData();
    const conf = getConfiguration();
    const couponKey = props.couponKey;
    const container = props.container;
    const coupon = betslipData.coupons[couponKey];
	const totalTaxAmount = coupon.totalTaxAmount? coupon.totalTaxAmount : 0;
	const showTaxes = taxesEnabled() && totalTaxAmount > 0;
    let potentialWinning = getCurrencyValue(coupon.potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMin =  getCurrencyValue(coupon.minPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMax =  getCurrencyValue(coupon.maxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let amountSrc = 0;

    const stakeTaxedJustAdvice = betslipContext.stakeTaxConfiguration.enabled && 
	 							 betslipContext.stakeTaxConfiguration.type === 'advice_for_online_distro';

    const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	  							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
	let stakeTaxedAmountSrc = 0;
	let stakeTaxedPotentialWinning = 0;
	// let stakeTaxedMinPotentialWinning = 0; // only for systembets
	// let stakeTaxedMaxPotentialWinning = 0; // only for systembets
    
    function changeVarOdd() {
        let oddVariation = coupon.oddVariation;
        if (oddVariation === 'NEVER') {
            oddVariation = 'ALWAYS';
        } 
        else {
            oddVariation = 'NEVER';
        }
    	betslipContext.changeOddVariation(oddVariation, true);
    }
    
    // bonusMulti
    let bonusDataMulti = null;
    let potentialWinningNoBonusMulti = 0;
    let bonusWinMulti = 0;
    let descBonusMulti = "Bonus";
    
    // bonusSystem
    let bonusSystemData = null;
    let descBonusSystem = "Bonus";
    
    if (container === 'singlebets') {
    	amountSrc = coupon.amountSingle;
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSingle;
    	}
    	
    } else if (container === 'multibets') {
    	amountSrc = coupon.amountMulti;
    	bonusDataMulti = coupon.multipleBonus;
    	if (bonusDataMulti && bonusDataMulti.applied) {
    		potentialWinningNoBonusMulti = getCurrencyValue(bonusDataMulti.potentialWinningNoBonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		bonusWinMulti = getCurrencyValue(bonusDataMulti.bonusAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		descBonusMulti = bonusDataMulti.description;
    	}
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountMulti;
    	}
    } else {
    	amountSrc = coupon.amountSystem;
    	bonusSystemData = coupon.bonusSystemData;
    	if (bonusSystemData && bonusSystemData.applied) {
    		descBonusSystem = bonusSystemData.description && bonusSystemData.description !== "" ? bonusSystemData.description : descBonusSystem;
    	} 
    	else {
    		bonusSystemData = {
    			applied : false	
    		};
    	}
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSystem;
    	}
    }

	let totalAmount = getCurrencyValue(amountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
    
    let stakeTaxedTotalAmount = null;
    const showTaxedTotalAmount = stakeTaxedForPurchase; // TO remove definetely if in the future we wont have a skin that requires it
	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
		stakeTaxedTotalAmount = getCurrencyValue(stakeTaxedAmountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
		stakeTaxedPotentialWinning = getCurrencyValue(coupon.stakeTaxedPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		// stakeTaxedMinPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMinPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		// stakeTaxedMaxPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMaxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
	}
	
    let taxedStakeAmountLabel = getLabel('betslip_alt.taxed_stake');
    let taxedStakeWinningLabel = getLabel('betslip_alt.taxed_stake_winning');
    if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    	taxedStakeAmountLabel = taxedStakeAmountLabel.replace(/{{PERCENTAGE}}/g,  betslipContext.stakeTaxConfiguration.percentage / 100 + "%");
    }
    
 // MAX PAID STUFF, IF THE CUSTOMER HAS IT IN ITS CONFIGURATION
    let maxPaidPotentialWinning = null;
    let maxPaidPotentialWinMin =  null;
    let maxPaidPotentialWinMax =  null;
    let maxPaidStakeTaxedPotentialWinning = null;
    
    if (container === 'systembets' ) {
    	if (conf.sbmw !== 0 && conf.mwspw) {
    		if (coupon.potentialWinning > conf.sbmw) {
    			maxPaidPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if (coupon.minPotentialWinning > conf.sbmw) {
    			maxPaidPotentialWinMin = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if (coupon.maxPotentialWinning > conf.sbmw) {
    			maxPaidPotentialWinMax = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if (coupon.stakeTaxedPotentialWinning > conf.sbmw) {
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    } else {
    	if (conf.mbmw !== 0 && conf.mwmpw) {
    		if (coupon.potentialWinning > conf.mbmw) {
    			maxPaidPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if (coupon.stakeTaxedPotentialWinning > conf.mbmw) {
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    const user = userContext.getUser();
//	const showFreebetAdvise = true;
	const showFreebetAdvise = user && user.logged && user.freebetCount > 0;
    const isLive = isLiveBetting(coupon.sections, container);

	return (
        <>
            {container === 'multibets' &&
                <>
                    {!betslipContext.betOptionsSectionMustBeShown() &&
                        <div className="cart__footer__betInputRow">
                            <span>{getLabel('betslip_alt.stake')}</span>
                            <AmountBetslipForm couponKey={couponKey} isEventForm={false} />
                        </div>
                    }
                    {conf.bak?.mob === true &&
                        <StakesPicker couponKey={couponKey} isEventForm={false} />
                    }
                </>
            }
            <div className="cart__footer__recap__tableContainer">
                <table className="cart__footer__recap__table">
                    <tbody>
                        {(container === 'singlebets' || container === 'systembets') &&
                            <tr>
                                <td>
                                    <div className="cart__footer__recap__description">{getLabel('betslip_alt.total_amount')}</div>
                                </td>
                                <td>
                                    <div className="cart__footer__recap__value">{totalAmount}</div>
                                </td>
                            </tr>
                        }
                        {container === 'multibets' &&
                            <tr>
                                <td>
                                    <div className="cart__footer__recap__description">{getLabel('betslip_alt.total_odds')}</div>
                                </td>
                                <td>
                                    <div className="cart__footer__recap__value">{coupon.totalOdd}</div>
                                </td>
                            </tr>
                        }
                        {bonusDataMulti && bonusDataMulti.applied &&
                            <>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{descBonusMulti}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{bonusWinMulti}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{getLabel('betslip_alt.winnings')}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{potentialWinningNoBonusMulti}</div>
                                    </td>
                                </tr>
                            </>
                        }
                        {showTaxedTotalAmount &&
                            <>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{taxedStakeAmountLabel}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{stakeTaxedTotalAmount}</div>
                                    </td>
                                </tr>
                            </>
                        }
                        {container === 'systembets' &&
                            <>                      
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{getLabel('betslip_alt.combs')}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{coupon.totalCombs}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{getLabel('betslip_alt.min_winnings')}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{maxPaidPotentialWinMin? maxPaidPotentialWinMin : potentialWinMin}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{getLabel('betslip_alt.max_winnings')}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{maxPaidPotentialWinMax? maxPaidPotentialWinMax : potentialWinMax}</div>
                                    </td>
                                </tr>
                                {bonusSystemData.applied &&
                                    <>
                                        <tr>
                                            <td>
                                                <div className="cart__footer__recap__description">{descBonusSystem.toUpperCase()}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="cart__footer__recap__description">{"Bonus Min."}</div>
                                            </td>
                                            <td>
                                                <div className="cart__footer__recap__value">{getCurrencyValue((bonusSystemData.bonusMin * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="cart__footer__recap__description">{"Bonus Max."}</div>
                                            </td>
                                            <td>
                                                <div className="cart__footer__recap__value">{getCurrencyValue((bonusSystemData.bonusMax * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                                            </td>
                                        </tr>
                                    </>
                                }
                            </>
                        }
                        {showTaxes &&
                            <>
                                <tr>
                                    <td>
                                        <div className="cart__footer__recap__description">{getLabel('printer.plain_ticket.footer.tax')} {'(' + getTaxPercentage() + ')'}</div>
                                    </td>
                                    <td>
                                        <div className="cart__footer__recap__value">{getCurrencyValue(totalTaxAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                                    </td>
                                </tr>
                            </>
                        }
                        <tr>
                            <td>
                                <div className="cart__footer__recap__description">{getLabel('betslip_alt.potential_winnings')}</div>
                            </td>
                            <td>
                                <div className="cart__footer__recap__value">
                                    {stakeTaxedForPurchase ? 
                                        maxPaidStakeTaxedPotentialWinning ? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning
                                        : 
                                        maxPaidPotentialWinning ? maxPaidPotentialWinning : potentialWinning
                                    }
                                </div>
                            </td>
                        </tr>
                        {stakeTaxedJustAdvice &&
                            <tr data-type="taxed-potential-winnings">
                                <td>
                                    <div className="cart__footer__recap__description">{taxedStakeWinningLabel}</div>
                                </td>
                                <td>
                                    <div className="cart__footer__recap__value">
                                        {maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning}
                                    </div>
                                </td>
                            </tr>
                        }
                        {conf.ovs?.tgs &&
                            <tr>
                                <td>
                                    <div className="cart__footer__recap__description">
                                        {getLabel('betslip_alt.odds_variation_toggle.label')}
                                    </div>
                                </td>
                                <td>
                                    <div className="cart__footer__recap__value">
                                        <div className="customInput customInput--toggle">
                                            <label>
                                                <input type="checkbox" checked={coupon.oddVariation !== 'NEVER'} onChange={changeVarOdd} />
                                                <span></span>
                                            </label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                {showFreebetAdvise &&
                    <div className="freeBetsPromptContainer">
                        {/* <span className="freeBetsPromptContainer__iconContainer"><i className={"fas fa-thumbs-up"} /></span> */}
                        <span className="freeBetsPromptContainer__textContainer">{getLabel('freebet.enabled')}</span> 
                    </div>
                }
                {!betslipContext.betOptionsSectionMustBeShown() &&
                    <BetslipButtons isLive={isLive} />
                }
            </div>
        </>
    );
}

export default PotentialWinBox;
